var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-layout"}},[_c('Menu',{attrs:{"bordered":true}}),_vm._v(" "),_c('Notice'),_vm._v(" "),_c('div',{staticClass:"header",class:_vm.background}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('foot')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b32b4c","hasScoped":true,"buble":{"transforms":{}}}!./src/layouts/header/template.html
// module id = 883
// module chunks = 0